import { render, staticRenderFns } from "./formAdd.vue?vue&type=template&id=5cf19e46&scoped=true"
import script from "./formAdd.vue?vue&type=script&lang=js"
export * from "./formAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf19e46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cf19e46')) {
      api.createRecord('5cf19e46', component.options)
    } else {
      api.reload('5cf19e46', component.options)
    }
    module.hot.accept("./formAdd.vue?vue&type=template&id=5cf19e46&scoped=true", function () {
      api.rerender('5cf19e46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/formAdd.vue"
export default component.exports